import { createWorker } from './createWorker';
const {
  host,
  protocol
} = window.location;
const workerUrl = `${protocol}//${host}/ui-extension/v1/worker.js`;
export function start() {
  window.addEventListener('message', initialize);
}
function initialize(event) {
  const data = event.data;
  if (data == null || typeof data.init !== 'string') return;
  const {
    worker
  } = createWorker({
    url: workerUrl,
    cardTitle: data.cardTitle
  });
  worker.postMessage({
    __replace: event.ports[0]
  }, [event.ports[0]]);
}